import React, { useCallback } from "react";
import classNames from "classnames";
import Slider from "rc-slider";


interface RangeSliderProps {
    width: number | string;
    disabled?: boolean;
    useTooltip?: boolean;
    min?: number;
    max?: number;
    value?: number;
    defaultValue?: number;
    onChange: (sliderValue: number) => void;
    "aria-label"?: string;
    "aria-labelledby"?: string;
    "aria-valuetext"?: (value: number) => string;
}

const RangeSlider: React.FC<RangeSliderProps> = (props) => {
    const {
        width,
        disabled = false,
        useTooltip = false,
        min = 1,
        max =100,
        value,
        defaultValue,
        onChange,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
    } = props;

    const onSlide = (sliderValue: number | number[]) => {
        if (Array.isArray(sliderValue)) {
            onChange(sliderValue[0]);
        } else {
            onChange(sliderValue);
        }
    };
    const renderHandle = useCallback((renderProps: any, props: any) => {
        return (
            <div {...renderProps.props}>
                <div className={classNames(
                         "fixed -top-9 -left-4.5 py-1.5 pr-2.5 pl-3 bg-black rounded-[6px] text-white font-[400] text-[12px] leading-[1.4] z-[9999]",
                         !props.dragging && "hidden"
                     )}
                >
                    {`${props.value}px`}
                </div>
            </div>
        );
    }, []);

    return (
        <div style={{ width }}>
            <Slider disabled={disabled}
                    step={1}
                    min={min}
                    max={max}
                    value={value}
                    defaultValue={defaultValue}
                    ariaLabelForHandle={ariaLabel}
                    ariaLabelledByForHandle={ariaLabelledBy}
                    ariaValueTextFormatterForHandle={ariaValueText}
                    handleRender={useTooltip ? renderHandle : undefined}
                    onChange={onSlide}
                    styles={{
                        rail: {
                            border: "3px solid #E4E4E4"
                        },
                        track: {
                            border: disabled ? "3px solid #BDBDBD" : "3px solid #441A98"
                        },
                        handle: {
                            width: 14,
                            height: 14,
                            border: disabled ? "3px solid #BDBDBD" : "3px solid #441A98",
                            backgroundColor: "white",
                            opacity: 1,
                        }
                    }}
            />
        </div>
    );
};

export default RangeSlider;